import { render, staticRenderFns } from "./SwitchboardOverview.vue?vue&type=template&id=476f2607&scoped=true&"
import script from "./SwitchboardOverview.vue?vue&type=script&lang=ts&"
export * from "./SwitchboardOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchboardOverview.vue?vue&type=style&index=0&id=476f2607&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f2607",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow,VSelect})
